export default class DialogBloc {
  constructor({ dialogRepository }) {
    this.dialogRepository = dialogRepository;
  }

  get dialogDetails$() {
    return this.dialogRepository.dialogDetails$;
  }

  toggleDialog(open) {
    this.dialogRepository.toggleDialog(open);
  }
}
